export const FETCH_ANNOUNCEMENTS = 'FETCH_ANNOUNCEMENTS'
export const ADD_ANNOUNCEMENT = 'ADD_ANNOUNCEMENT'
export const HANDLE_ANNOUNCEMENT_LOADING = 'HANDLE_ANNOUNCEMENT_LOADING'